"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Parser = _interopRequireDefault(require("./Parser"));

var _getCurrentHref = _interopRequireDefault(require("./utils/getCurrentHref"));

var CommentsCount = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(CommentsCount, _PureComponent);

  function CommentsCount() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = CommentsCount.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var handleParse = this.props.handleParse;
    handleParse();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _this$props$href = _this$props.href,
        href = _this$props$href === void 0 ? (0, _getCurrentHref["default"])() : _this$props$href,
        children = _this$props.children;
    return _react["default"].createElement("span", {
      className: "fb-comments-count",
      "data-href": href
    }, children);
  };

  return CommentsCount;
}(_react.PureComponent);

(0, _defineProperty2["default"])(CommentsCount, "defaultProps", {
  href: undefined,
  children: undefined
});

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react["default"].createElement(_Parser["default"], null, function (_ref) {
    var handleParse = _ref.handleParse;
    return _react["default"].createElement(CommentsCount, (0, _extends2["default"])({}, props, {
      handleParse: handleParse,
      ref: ref
    }));
  });
});

exports["default"] = _default;